import { BreadCrumbItemType } from "../../common/types";

export const COMMON_ACTIONS = {
  ADD_BREADCRUMB: "ADD_BREADCRUMB",
  REMOVE_BREADCRUMB: "REMOVE_BREADCRUMB",
  SET_HISTORY: "SET_HISTORY",
  RESET_HISTORY: "RESET_HISTORY",
  SET_VERTICAL: "SET_VERTICAL",
  RESET_VERTICAL: "RESET_VERTICAL",
  SET_CONTRACT_TYPE: "SET_CONTRACT_TYPE",
  RESET_CONTRACT_TYPE: "RESET_CONTRACT_TYPE",
};

export const addBreadCrumbThunk = (breadCrumbs: BreadCrumbItemType[]) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.ADD_BREADCRUMB,
        payload: breadCrumbs,
      });
    } catch (error) {}
  };
};

export const removeBreadCrumbThunk = (breadCrumbs: BreadCrumbItemType[]) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.REMOVE_BREADCRUMB,
        payload: breadCrumbs,
      });
    } catch (error) {}
  };
};

export const setHistoryThunk = (path: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.SET_HISTORY,
        payload: path,
      });
    } catch (err) {}
  };
};

export const resetHistoryThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.RESET_HISTORY,
      });
    } catch (err) {}
  };
};

export const setVerticalForKeyClauseDashboard = (
  feature: string,
  data: any
) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.SET_VERTICAL,
        payload: {
          feature: feature,
          data: data,
        },
      });
    } catch (err) {}
  };
};

export const resetVerticalForKeyClauseDashboard = (feature: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.RESET_VERTICAL,
        payload: {
          feature: feature,
        },
      });
    } catch (err) {}
  };
};

export const setContractTypeForFeature = (feature: string, data: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.SET_CONTRACT_TYPE,
        payload: {
          feature: feature,
          data: data,
        },
      });
    } catch (err) {}
  };
};

export const resetContractTypeForFeature = (feature: string) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: COMMON_ACTIONS.RESET_CONTRACT_TYPE,
        payload: {
          feature: feature,
        },
      });
    } catch (err) {}
  };
};
